/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsDelete } from "../funcs/agentsDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteAgentRequest,
  DeleteAgentSecurity,
} from "../models/operations/deleteagent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AgentsDeleteMutationVariables = {
  request: DeleteAgentRequest;
  security?: DeleteAgentSecurity | undefined;
  options?: RequestOptions;
};

export type AgentsDeleteMutationData = void;

export type AgentsDeleteMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * delete agents
 */
export function useAgentsDeleteMutation(
  options?: MutationHookOptions<
    AgentsDeleteMutationData,
    AgentsDeleteMutationError,
    AgentsDeleteMutationVariables
  >,
): UseMutationResult<
  AgentsDeleteMutationData,
  AgentsDeleteMutationError,
  AgentsDeleteMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAgentsDeleteMutation(client, options),
    ...options,
  });
}

export function mutationKeyAgentsDelete(): MutationKey {
  return ["@gram/client", "agents", "delete"];
}

export function buildAgentsDeleteMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AgentsDeleteMutationVariables,
  ) => Promise<AgentsDeleteMutationData>;
} {
  return {
    mutationKey: mutationKeyAgentsDelete(),
    mutationFn: function agentsDeleteMutationFn({
      request,
      security,
      options,
    }): Promise<AgentsDeleteMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
